import React from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

/**
 * Единый текстовый компонент.
 * variant: regular | medium | semibold | bold
 * color: default | muted | primary | danger | white
 */
export const Text = ({
  variant = "regular",
  size = 14,
  color = "default",
  className,
  style,
  children,
  ...rest
}) => (
  <span
    className={cn(styles.text, styles[variant], styles[`color-${color}`], className)}
    style={{ fontSize: size, ...style }}
    {...rest}
  >
    {children}
  </span>
);

export const RegularText = (props) => <Text variant="regular" {...props} />;
export const MediumText = (props) => <Text variant="medium" {...props} />;
export const SemiBoldText = (props) => (
  <Text variant="semibold" size={16} {...props} />
);
export const BoldText = (props) => <Text variant="bold" size={16} {...props} />;
